import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

export interface VerifyIdentityVariables {
  input: {
    email: string;
    phoneNumber: string;
    dateOfBirth: string;
  };
}

export interface VerifyIdentityResponse {
  verifyYourIdentity: {
    status: string;
    verificationToken: string | null;
    maskedPhoneNumber: string | null;
  };
}

@Injectable({
  providedIn: 'root',
})
export class VerifyIdentityGraphQLService extends Mutation<VerifyIdentityResponse, VerifyIdentityVariables> {
  document = gql`
    mutation VerifyYourIdentity($input: VerifyYourIdentityInput!) {
      verifyYourIdentity(input: $input) {
        status
        verificationToken
        maskedPhoneNumber
      }
    }
  `;
}
